import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormbirdSharedModule } from '@formbird/shared';
import { FormbirdTypesModule } from '@formbird/types';
import { ClientAccessService } from './services/access/client-access.service';
import { BroadcastService } from './services/broadcast/broadcast.service';
import { DataService } from './services/data/data.service';
import { RestDataService } from './services/data/rest-data.service';
import { ClientSystemHeaderService } from './services/document/client-system-header.service';
import { CurrentDocumentService } from './services/document/current-document.service';
import { DocumentService } from './services/document/document.service';
import { TemplateService } from './services/document/template.service';
import { UnsavedDocumentService } from './services/document/unsaved-document.service';
import { LocalStorageService } from './services/local-storage/local-storage.service';
import { OfflineStatusService } from './services/offline-status/offline-status.service';
import { PhoneService } from './services/phone/phone.service';
import { SearchFilterService } from './services/search/search-filter.service';
import { SearchService } from './services/search/search.service';
import { SessionTestService } from './services/session/session-test.service';
import { ControlStateSaveService } from './services/state/control-state-save.service';
import { LoggedInUserService } from './services/user/logged-in-user.service';
import { LazyScriptLoaderService } from './services/lazyload/lazy-script-loader.service';
import { IndexedDBQueueService } from './services/indexeddb/indexed-dbqueue.service';
import { IndexedDBPropertiesService } from './services/indexeddb/indexed-dbproperties.service';
import { PageVisibilityService } from './services/page-visibility.service';
import { IndexedDBService } from './services/indexeddb/indexed-db.service';
import { ElasticIndexedDBService } from './services/indexeddb/elastic-indexed-db.service';
import { IndexedDBConnectorService } from './services/indexeddb/indexed-dbconnector.service';
import { DexieSearchService } from './services/indexeddb/dexie-search.service';
import { UserSettingsService } from './services/user/user-settings.service';
import { FileProviderService } from './services/file/file-provider.service';
import { OfflineUtilService } from './services/offline/offline-util.service';
import { ChangedDocumentService } from './services/document/changed-document.service';
import { CurrentChildDocumentService } from './services/document/current-child-document.service';
import { ComponentService } from './services/component/component.service';
import { FormColorService } from './services/layout/form-color.service';
import { DefaultStateService } from './services/navigation/default-state.service';
import { NavigationService } from './services/navigation/navigation.service';
import { ModifiedCSSService } from './services/layout/modified-css.service';
import { ValidationService } from './services/validation/validation.service';
import { CustomFieldPreprocessorService } from './services/preprocessor/custom-field/custom-field-preprocessor.service';
import { PreProcessorFieldService } from './services/preprocessor/pre-processor-field.service';
import { ModifiedFieldService } from './services/document/modified-field.service';
import { TabService } from './services/tab/tab.service';
import { ClientRulesService } from './services/rules/client-rules.service';
import { ClientIncludeRuleSetService } from './services/rules/client-include-rule-set.service';
import { RuleEngineService } from './services/rules/rule-engine.service';
import { NotificationService } from './services/notification/notification.service';
import { ChildDocumentListService } from './services/document/child-document-list.service';
import { DocumentSaveService } from './services/document/document-save.service';
import { MandatoryFieldService } from './services/document/mandatory-field.service';
import { DocumentUpdateService } from './services/document/document-update.service';
import { UrlService } from './services/url/url.service';
import { ClientResourceService } from './services/resource/client-resource.service';
import { StorageEventService } from './services/event/storage-event.service';
import { CurrentDocumentInfoService } from './services/document/current-document-info.service';
import { TemplateHtmlService } from './services/document/template-html.service';
import { VendorLibraryService } from './services/vendor-library/vendor-library.service';
import { AppStore } from './redux/store/app.store';
import { RootStore } from './redux/store/root.store';
import { IApplicationState } from './redux/state/application.state';
import { getStore } from './redux/store/store';
import { UrlBasePathService } from './utils/UrlBasePathUtil';
import { FinaliseValueFieldService } from './services/document/finalise-value-field.service';

// TODO: add dialog to entry files in app.module.ts

export function appStoreFactory() {
  return new RootStore();
}

@NgModule({
  declarations: [],
  entryComponents: [],
  imports: [
    HttpClientModule,
    FormbirdSharedModule,
    FormbirdTypesModule
  ],
  exports: [],
  providers: [
    {provide: AppStore, useFactory: appStoreFactory},
    LoggedInUserService,
    LocalStorageService,
    DataService,
    RestDataService,
    ClientAccessService,
    BroadcastService,
    DocumentService,
    TemplateService,
    ComponentService,
    CurrentDocumentService,
    CurrentChildDocumentService,
    CurrentDocumentInfoService,
    UnsavedDocumentService,
    ChangedDocumentService,
    ClientSystemHeaderService,
    SearchFilterService,
    OfflineStatusService,
    PhoneService,
    SearchService,
    ControlStateSaveService,
    SessionTestService,
    LazyScriptLoaderService,
    IndexedDBQueueService,
    IndexedDBPropertiesService,
    IndexedDBService,
    ElasticIndexedDBService,
    IndexedDBConnectorService,
    DexieSearchService,
    PageVisibilityService,
    UserSettingsService,
    FileProviderService,
    OfflineUtilService,
    FormColorService,
    ModifiedCSSService,
    DefaultStateService,
    NavigationService,
    ValidationService,
    CustomFieldPreprocessorService,
    PreProcessorFieldService,
    ModifiedFieldService,
    TabService,
    ClientRulesService,
    ClientIncludeRuleSetService,
    RuleEngineService,
    NotificationService,
    ChildDocumentListService,
    DocumentSaveService,
    DocumentUpdateService,
    MandatoryFieldService,
    TemplateHtmlService,
    UrlService,
    ClientResourceService,
    StorageEventService,
    UrlBasePathService,
    VendorLibraryService,
    FinaliseValueFieldService
  ]
})
export class FormbirdServicesModule {
  constructor(appStore: AppStore<IApplicationState>) {
    const store = getStore();
    appStore.provideStore(store);
  }
}
